var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.show
    ? _c(
        "div",
        {
          class: _vm.$style.bottom_banner,
          style: Object.assign({}, _vm.blackFridayBannerStyles),
        },
        [
          _c(
            "div",
            {
              class: _vm.$style.banner,
              style: {
                backgroundImage:
                  "url(https://cdn.ganttpro.com/app/imgs/pricing/BF_bottom_banner.png)",
              },
            },
            [
              _c(
                "div",
                {
                  class: _vm.$style.wrapper,
                  on: { click: _vm.onClickToBilling },
                },
                [
                  _c("div", { class: _vm.$style.left_side }, [
                    _vm._v("\n        Black Weeks\n      "),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { class: _vm.$style.right_side },
                    [
                      _c("div", { class: _vm.$style.text }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.locales("bf_top_banner_description")) +
                            "\n        "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("fridayButton", {
                        style: { marginRight: "72px" },
                        attrs: {
                          readonly: true,
                          bold: true,
                          styles: { fontSize: "14px", lineHeight: "20px" },
                          text: _vm.locales("bf_banner_period"),
                        },
                      }),
                      _vm._v(" "),
                      _c("fridayButton", {
                        style: { marginRight: "72px" },
                        attrs: { small: false },
                      }),
                    ],
                    1
                  ),
                ]
              ),
              _vm._v(" "),
              _c("icon-button", {
                style: {
                  position: "absolute",
                  right: "16px",
                  top: "50%",
                  transform: "translateY(-50%)",
                },
                attrs: { icon: { name: "close-1" }, colors: _vm.buttonColors },
                on: { onClick: _vm.onCloseClick },
              }),
            ],
            1
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }